import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createTRPCContext } from "@trpc/tanstack-react-query";
import { useUser } from "@iscr/xAppLib/Hooks";
import { getTRPCClient } from "xAppLib/providers/trpcClient";
const { TRPCProvider: Provider, useTRPC } = createTRPCContext();
export { useTRPC };
const client = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
});
export function QueryProvider({ children }) {
    const user = useUser();
    const uid = Boolean(user.uid);
    useEffect(() => {
        if (uid) {
            // Only clear the cache for an authenticated user change. Typically when logging out, but there
            // may also be times when the user changes (e.g. impersonation).
            return () => {
                // We could be selective here and try to only clear user-related cache, but that would rely on
                // query key functions properly marking a query as user-related. Ideally we'd just blow away the
                // tree from here and start from scratch, but we have component-based state that needs to persist
                // on login (e.g. order flow allows starting the form, and logging in later).
                client.clear();
            };
        }
    }, [uid]);
    return (_jsx(QueryClientProvider, { client: client, children: _jsx(Provider, { queryClient: client, trpcClient: getTRPCClient(), children: children }) }));
}
